<template>
<div>
    <button v-if="parseInt(orden.tipo_orden) === 1" class="button is-info is-small" @click="showBoxProducto = true">Agregar Productos</button>
    <b-field class="file" v-if="parseInt(orden.tipo_orden) === 1 && orden.is_new">
        <b-upload v-model="file">
            <a class="button is-primary is-small">
                <b-icon icon="upload"></b-icon>
                <span>Importar Productos</span>
            </a>
        </b-upload>
        <span class="file-name" v-if="file">{{ file.name }}</span>
        <button class="button is-info is-small" v-if="file" @click.prevent="importProducts">Cargar</button>
    </b-field>
    <button v-if="parseInt(orden.tipo_orden) === 2" class="button is-info is-small" @click="addService">Agregar Servicios</button>
    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
            <th class="has-background-link has-text-centered" style="width: 10%">Marca</th>
            <th class="has-background-link" style="width: 32%">Descripción</th>
            <th class="has-background-link has-text-centered" style="width: 10%">UND</th>
            <th class="has-background-link has-text-centered" style="width: 10%">CANT.</th>
            <th v-if="orden.es_importacion" class="has-background-link has-text-centered" style="width: 10%">P. FOB</th>
            <th class="has-background-link has-text-centered" style="width: 10%">{{ orden.es_importacion ? "P.CIF." :
                "P.U." }}</th>
            <th class="has-background-link has-text-centered" style="width: 10%">SUBTOTAL</th>
            <th class="has-background-link" style="width: 15%">OBS</th>
            <th class="has-background-link" style="width: 3%"></th>
        </thead>
        <tbody>
            <tr v-for="(item, index) in orden.orden_items" :key="index + '_item'">
                <td class="has-text-centered ">
                    <b-select placeholder="Marca" id="brand" size="is-small" v-model="item.marca.id_marca">
                        <option v-for="(marca, index) in data.marcas" :key="index + '_brand'" :value="marca.id_marca">
                            {{ marca.descripcion }}</option>
                    </b-select>
                </td>
                <td>
                    <div v-if="parseInt(orden.tipo_orden) === 1">
                        {{ item.descripcion }}
                    </div>
                    <div v-else>
                        <ValidationProvider rules="required" v-slot="{ errors, valid }">
                            <b-field :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                                <b-input v-model="item.descripcion" size="is-small"></b-input>
                            </b-field>
                        </ValidationProvider>
                    </div>
                </td>
                <td class="has-text-centered">
                    <ValidationProvider rules="required" v-slot="{ errors, valid }">
                        <b-field :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                            <b-select placeholder="Unidad" size="is-small" v-model="item.unidad.id_unidad">
                                <option v-for="(unidad, index) in data.unidades" :value="unidad.id_unidad" :key="index + '_unit'">{{ unidad.simbolo }}</option>
                            </b-select>
                        </b-field>
                    </ValidationProvider>
                </td>
                <td class="has-text-centered">
                    <ValidationProvider rules="required" v-slot="{ errors, valid }">
                        <b-field :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                            <b-input size="is-small" v-model="item.cantidad"></b-input>
                        </b-field>
                    </ValidationProvider>
                </td>
                <td v-if="orden.es_importacion" class="has-text-centered">
                    <ValidationProvider rules="required" v-slot="{ errors, valid }">
                        <b-field :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                            <b-input size="is-small" v-model="item.precio_fob"></b-input>
                        </b-field>
                    </ValidationProvider>
                </td>
                <td class="has-text-centered">
                    <ValidationProvider rules="required" v-slot="{ errors, valid }">
                        <b-field :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
                            <b-input size="is-small" v-model="item.precio_unitario"></b-input>
                        </b-field>
                    </ValidationProvider>
                </td>
                <td class="has-text-centered">
                    {{ (item.precio_unitario * item.cantidad) | amount }}
                </td>
                <td>
                    <b-field>
                        <b-input size="is-small" v-model="item.observacion"></b-input>
                    </b-field>
                </td>
                <td>
                    <b-button type="is-danger" icon-right="delete" @click="deleteProductAdded(index)" />
                </td>
            </tr>
            <tr>
                <td colspan="5">SubTotal:</td>
                <td class="has-text-centered">{{ sub_total_wo | amount }}</td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td colspan="3">Descuento:</td>
                <td>
                    <b-select size="is-small" placeholder="Tipo de Descuento" v-model="orden.tipo_descuento">
                        <option value="1">Porcentaje</option>
                        <option value="2">Valor</option>
                    </b-select>
                </td>
                <td class="has-text-centered">
                    <b-field>
                        <b-input size="is-small" v-model="orden.descuento"></b-input>
                    </b-field>
                </td>
                <td class="has-text-centered">{{ sub_total_wd | amount }}</td>
                <td></td>
                <td></td>
            </tr>
            <tr v-for="(item, index) in orden.orden_impuestos" :key="index + '_tax'">
                <td colspan="4">{{ item.descripcion }}</td>
                <td class="has-text-centered">
                    <b-input size="is-small" v-model="item.valor"></b-input>
                </td>
                <td class="has-text-centered">
                    {{ getValorImpuesto(item) | amount }}
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td colspan="5">TOTAL:</td>
                <td class="has-text-centered">{{ total_orden | amount }}</td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    <div class="nj-flx">
        <button class="nj-button c-green" @click="passes(register)" :disabled="disable_register"><i class="mdi mdi-content-save"></i>{{ orden.id_orden ? "Actualizar" :
            "Registrar" }}</button>
        <button class="nj-button" @click="cerrar()"><i class="mdi mdi-keyboard-backspace"></i>Regresar</button>
    </div>
    <b-modal :active.sync="showBoxProducto" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-Box>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">PRODUCTOS</p>
            </header>
            <section class="modal-card-body">
                <div class="columns">
                    <div class="column">
                        <b-field label="Categoría">
                            <b-select v-model="categoria_producto" @change.native="loadTiposProducto">
                                <option value="-1">Todos</option>
                                <option v-for="(categoria, index) in data.categorias_producto" :value="categoria.id_categoria_producto" :key="index + '_categoria'">{{
                                    categoria.descripcion }}
                                </option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Tipo">
                            <b-select v-model="tipo_producto" @change.native="loadProducts">
                                <option value="-1">Todos</option>
                                <option v-for="(tipo, index) in data.tipos_producto" :value="tipo.id_tipo_producto" :key="index + '_tipo_producto'">{{ tipo.descripcion }}</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Buscar">
                            <b-input v-model="tbl_producto.search" @input="loadProductsType"></b-input>
                        </b-field>
                    </div>
                </div>
                <b-table :data="tbl_producto.data" :loading="tbl_producto.loading" paginated backend-pagination :total="tbl_producto.total" :per-page="tbl_producto.perPage" aria-next-label="Siguiente"
                    aria-previous-label="Anterior" aria-page-label="Pág." aria-current-label="Pág. actual" @page-change="onPageProductoChange">
                    <template slot-scope="props">
                        <b-table-column field="descripcion" label="Producto">{{ props.row.producto_variacion_id.producto.nombre }}</b-table-column>
                        <b-table-column label="Unidad">{{ props.row.producto_variacion_id.producto.unidad.simbolo }}</b-table-column>
                        <b-table-column>
                            <b-button @click="selectProduct(props.row)" type="is-success" icon-right="plus" />
                        </b-table-column>
                    </template>
                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>No se encontraron productos</p>
                            </div>
                        </section>
                    </template>
                </b-table>
                <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" v-if="tbl_producto.data_selected.length">
                    <tr>
                        <th>Producto</th>
                        <th>Unidad</th>
                        <th></th>
                    </tr>
                    <tr v-for="(item, index) in tbl_producto.data_selected" :key="index + '_data'">
                        <td>{{ item.producto_variacion_id.producto.nombre }}</td>
                        <td>{{ item.producto_variacion_id.producto.unidad.simbolo }}</td>
                        <td>
                            <b-button :key="index + '_button'" type="is-danger" icon-right="delete" @click="deleteProductSelected(index)" />
                        </td>
                    </tr>
                </table>
            </section>
            <div class="nj-flx">
                <button class="button" type="button" @click="showBoxProducto = false">Cerrar</button>
                <button class="button is-primary" @click="addProduct">Agregar</button>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { ValidationProvider } from "vee-validate"
import { mapGetters, mapMutations } from "vuex"
import { taxesType } from "../constants/constants"
import { PedidoItemsService, ResponseStatus, UsuarioService } from "../services"
import Toast from "../util/toast"
import moment from "moment"
import { OrdenCompraEvent, OrdenCompraEventTypes } from "../util/events"

export default {
    props: {
        passes: null,
        orden: null,
    },
    name: "OrdenDetail",
    components: {
        ValidationProvider
    },
    data() {
        return {
            data: {
                unidades: [],
                marcas: [],
                categorias_producto: [],
                tipos_producto: []
            },
            file: null,
            disable_register: false,
            showBoxProducto: false,
            tipo_producto: -1,
            categoria_producto: -1,
            tbl_producto: {
                data: [],
                data_selected: [],
                total: 0,
                perPage: 10,
                page: 1,
                loading: false,
                search: ""
            },
            oci_orden: 1,
            pei_id: null,
        }
    },
    methods: {
        ...mapMutations("product", ["cancelInventario"]),
        loadProductsType: _.debounce(function () {
            this.loadProducts()
        }, 500),
        loadProducts() {
            let _self = this
            _self.tbl_producto.loading = true
            axios
                .post("/producto/list", {
                    search: this.tbl_producto.search,
                    length: this.tbl_producto.perPage,
                    start: (this.tbl_producto.page - 1) * this.tbl_producto.perPage,
                    categoria: this.categoria_producto,
                    tipo: this.tipo_producto,
                })
                .then(
                    response => {
                        _self.tbl_producto.data = response.data.data
                        _self.tbl_producto.total = response.data.total
                        _self.tbl_producto.loading = false
                    },
                    () => {
                        _self.tbl_producto.loading = false
                    }
                )
        },
        loadUnidades() {
            let _self = this
            axios.post("/unidad/get-unidad").then(
                res => (_self.data.unidades = res.data),
            )
        },
        loadMarcas() {
            let _self = this
            axios.post("/marca/get-marcas").then(
                res => (_self.data.marcas = res.data),
            )
        },
        loadCategorias() {
            axios
                .get("/categoria-producto/list")
                .then(res => {
                    this.data.categorias_producto = res.data
                })
        },
        loadTiposProducto() {
            this.tipo_producto = -1
            axios
                .get(
                    "/tipo-producto/get-categoria?id_categoria=" + this.categoria_producto
                )
                .then(res => (this.data.tipos_producto = res.data))
            this.loadProducts()
        },
        onPageProductoChange(page) {
            this.tbl_producto.page = page
            this.loadProducts()
        },
        selectProduct(row) {
            if (
                !this.tbl_producto.data_selected.some(
                    prod =>
                        prod.producto_variacion_id.id_producto_variacion ===
                        row.producto_variacion_id.id_producto_variacion &&
                        prod.producto_variacion_id.producto.id_producto ===
                        row.producto_variacion_id.producto.id_producto
                ) &&
                !this.orden.orden_items.some(
                    item =>
                        item.producto_variacion.producto_variacion_id
                            .id_producto_variacion ===
                        row.producto_variacion_id.id_producto_variacion &&
                        item.producto_variacion.producto_variacion_id.producto
                            .id_producto === row.producto_variacion_id.producto.id_producto
                )
            ) {
                row.oci_orden = this.oci_orden
                this.tbl_producto.data_selected.push(row)
                this.oci_orden++
            }
        },
        addProduct() {
            // agregando los items a la OC
            this.tbl_producto.data_selected.forEach(row => {
                let item = {
                    descripcion: "",
                    marca: {},
                    unidad: {},
                    cantidad: 1,
                    pid_id: null,
                }
                item.producto_variacion = row
                item.descripcion = row.producto_variacion_id.producto.nombre
                item.marca = {
                    id_marca: row.producto_variacion_id.producto.marca.id_marca
                }
                item.unidad = {
                    id_unidad: row.producto_variacion_id.producto.unidad.id_unidad
                }
                item.cantidad = row.producto_variacion_id.producto.pid_cantidad_aprobada
                item.oci_orden = row.oci_orden
                item.pid_id = row.producto_variacion_id.pid_id
                this.orden.orden_items.push(item)
            })
            this.tbl_producto.data_selected = []
            this.showBoxProducto = false
        },
        addService() {
            let item = {
                descripcion: "",
                marca: {
                    id_marca: 0
                },
                unidad: { id_unidad: null }
            }
            // Colocando por defecto "sin marca"
            if (this.orden.tipo_orden == 1) {
                item.marca = {
                    id_marca: row.producto_variacion_id.producto.marca.id_marca
                }
            }
            item.oci_orden = this.oci_orden
            this.orden.orden_items.push(item)
            this.oci_orden++
        },
        deleteProductAdded(index) {
            this.orden.orden_items.splice(index, 1)
        },
        deleteProductSelected(index) {
            this.tbl_producto.data_selected.splice(index, 1)
        },
        getValorImpuesto(item) {
            const igv = this.orden.orden_impuestos.find(ele => ele.descripcion === taxesType.IGV).valor
            const factor_igv = igv ? (1 + igv) : 1
            let _valor = 0
            switch (item.descripcion) {
                case taxesType.IGV:
                    _valor = item.valor * this.sub_total_wd
                    break
                case taxesType.PERCEPCION:
                    _valor = item.valor * (this.sub_total_wd * factor_igv)
                    break
                case taxesType.DETRACCION:
                    _valor = -item.valor * (this.sub_total_wo * factor_igv)
                    _valor = Math.round(_valor)
                    break
                case taxesType.RETENCION:
                    _valor = -item.valor * (this.sub_total_wo * factor_igv)
                    break
            }
            // return item.valor_aplicado
            item.valor_aplicado = _valor
            return item.valor_aplicado
        },
        register() {
            if (this.orden.orden_items.length === 0) {
                this.$buefy.toast.open({
                    message: `Ingrese al menos un producto`,
                    type: "is-danger"
                })
                return
            }
            this.disable_register = true
            let orden_data = _.cloneDeep(this.orden)
            orden_data.monto_con_impuesto = this.total_orden
            orden_data.monto_sin_impuesto = this.sub_total_wo
            orden_data.pei_id = this.pei_id // agregando el ID del pedido
            orden_data.fecha_pago = moment(this.orden.fecha_pago).format(
                "YYYY-MM-DD"
            )
            orden_data.logistica = {
                id_usuario: this.usuario.usu_id
            }
            this.disable_register = true
            if (this.orden.id_orden) {
                axios
                    .post("/orden/update-orden", orden_data)
                    .then(
                        () => {
                            this.disable_register = false
                            this.$buefy.toast.open({
                                message: `Se actualizo con exito la orden`,
                                type: "is-success"
                            })
                            this.$router.push("/orden")
                        },
                        err => {
                            this.$buefy.toast.open({
                                message: err.response.data.message,
                                type: "is-danger"
                            })
                            this.disable_register = false
                        }
                    )
                    .catch(err => {
                        this.$buefy.toast.open({
                            message: err.response.data.message,
                            type: "is-danger"
                        })
                        this.disable_register = false
                    })
            } else {
                axios
                    .post("/orden/register-orden", orden_data)
                    .then(
                        () => {
                            this.disable_register = false
                            this.$buefy.toast.open({
                                message: `Se registro con exito la orden`,
                                type: "is-success"
                            })
                            this.$router.push("/orden")
                        },
                        err => {
                            this.disable_register = false
                            this.$buefy.toast.open({
                                message: err.response.data.message,
                                type: "is-danger"
                            })
                        }
                    )
                    .catch(err => {
                        this.$buefy.toast.open({
                            message: err.response.data.message,
                            type: "is-danger"
                        })
                        this.disable_register = false
                    })
            }
        },
        importProducts() {
            let data = new FormData()
            data.append("file", this.file)
            axios
                .post("/producto/import-products", data, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(
                    response => {
                        this.$buefy.toast.open({
                            message: "Se cargo los items correctamente",
                            type: "is-success"
                        })
                        this.file = null
                        response.data.forEach(e => {
                            this.orden.orden_items.push(e)
                        })
                    },
                    err => {
                        this.$buefy.toast.open({
                            message: err.response.data.message,
                            type: "is-danger"
                        })
                    }
                )
        },
        loadRenovateStock() {
            if (this.fromInv) {
                if (this.lista.length > 0) {
                    this.lista.forEach(row => {
                        let item = { descripcion: "", marca: {}, unidad: {} }
                        item.producto_variacion = row.inventario_id.producto_variacion
                        item.descripcion = row.inventario_id.producto_variacion.producto_variacion_id.producto.nombre
                        item.marca = {
                            id_marca: row.inventario_id.producto_variacion.producto_variacion_id.producto.marca.id_marca
                        }
                        item.unidad = { id_unidad: row.inventario_id.producto_variacion.producto.unidad.id_unidad }
                        item.cantidad = row.stock_minimo - row.stock_digital
                        this.orden.orden_items.push(item)
                    })
                }
                this.cancelInventario()
            }
        },
        cerrar() {
            this.$router.push("/orden")
        },
        cargarItemsDePedido(pei_id) {
            this.pei_id = pei_id
            PedidoItemsService
                .buscarProductosxPedido({
                    pedido_items: {
                        pei_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        const data = response.data
                        data.forEach(item => {
                            this.selectProduct(item)
                        })
                        this.addProduct()
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)

                })
        }
    },
    computed: {
        ...mapGetters("product", ["lista", "fromInv"]),
        usuario() {
            return UsuarioService.getUsuario()
        },
        sub_total_wo() {
            return this.orden.orden_items.reduce(
                (accu, curval) => accu + curval.precio_unitario * curval.cantidad,
                0
            )
            // return 0
        },
        sub_total_wd() {
            let val = this.sub_total_wo.valueOf()
            // @note Evaluando si el usuario ingresa un descuento ya sea un valor o un porcentaje
            if (parseInt(this.orden.tipo_descuento) === 1) {
                return val * (1 - this.orden.descuento / 100)
            } else {
                return val - this.orden.descuento
            }
            // return this.sub_total_wo
        },
        total_orden() {
            return this.orden.orden_impuestos
                .reduce(
                    (accu, curval) => accu + curval.valor_aplicado,
                    this.sub_total_wd
                )
            // return 0
        },
    },
    mounted() {
        // Recuperando el max de oci_orden
        if (this.orden != undefined && this.orden != null) {
            this.orden.orden_items.forEach(item => {
                if (item.oci_orden > this.oci_id) {
                    this.oci_id = item.oci_id
                }
            })
        }
        this.loadProducts()
        this.loadUnidades()
        this.loadMarcas()
        this.loadCategorias()
        this.loadRenovateStock()
        OrdenCompraEvent.$on(OrdenCompraEventTypes.cargarItemsDePedido, this.cargarItemsDePedido)
    }
}
</script>

<style>
#brand {
    width: 100%;
}

.modal-card {
    width: 960px !important;
}
</style>
